import React from 'react'
import '../../styles/Diagnostic/DiagnosticElectricity.css'
import { Fade } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import diagnosticElectricitySection2 from '../../assets/diagnostic/diagnostic-electricity-section2.jpg'
import diagnosticElectricitySection3 from '../../assets/diagnostic/diagnostic-electricity-section3.jpg'
import AccordionText from '../Utils/AccordionText'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function DiagnosticElectricity() {

    const section3AccordionData = [
        {
            title: "Expertise certifiée",
            text: "Nos diagnostiqueurs spécialisés disposent des qualifications et des certifications nécessaires pour effectuer des diagnostics électricité précis et conformes aux normes en vigueur."
        }, {
            title: "Sécurité et conformité",
            text: "Nous réalisons une évaluation complète de vos installations électriques, identifiant les anomalies et les risques potentiels pour les occupants. Ce diagnostic est crucial pour prévenir les accidents et garantir la conformité de votre bien."
        }, {
            title: "Rapport détaillé et clair",
            text: "E5M Diagnostic fournit un rapport de diagnostic électricité exhaustif, détaillant les résultats des vérifications effectuées et les recommandations pour d’éventuelles mises en conformité. Ce document est indispensable pour informer les futurs acheteurs ou locataires sur l’état des installations électriques."
        }, {
            title: "Réactivité et professionnalisme",
            text: "Conscients de l’importance des délais dans le cadre d’une transaction immobilière, nous nous engageons à intervenir rapidement et à fournir un service de diagnostic électricité de la plus haute qualité."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic Électricité - E5M Diagnostics" />
                <meta name="description" content="Diagnostic Électricité sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic Électricité - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic Électricité sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/diagnostic-électricité" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/diagnostic-électricité" />
            </Helmet>

            <BrowserView>
                <div id='diagnosticElectricity'>
                    <div id='header'>
                        <div id='diagnosticElectricityHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Diagnostic Électricité</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticElectricitySection1'>
                        <Fade direction={'down'} duration={500}>
                            <h1 className='sectionTitle'>Votre partenaire de confiance pour un diagnostic électricité sécurisé</h1>
                            <div className='sectionText'>
                                La sécurité des installations électriques est une priorité absolue pour la vente ou la location de votre propriété. E5M Diagnostics comprends les enjeux liés à un diagnostic électricité fiable et conforme.
                                Nos experts certifiés vous accompagnent pour réaliser ce diagnostic essentiel, vous permettant de garantir la sécurité de votre bien et de répondre aux exigences réglementaires.
                            </div>
                        </Fade>
                    </div>
                    <Row id='diagnosticElectricitySection2'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticElectricitySection2Left'>
                                    <h1 className='sectionTitle'>Que ce que c'est diagnostic éléctricité</h1>
                                    <div className='sectionText'>
                                        Il est obligatoire d’effectuer un diagnostic électricité de l’installation intérieure afin d’évaluer les risques pouvant mettre en danger la sécurité des personnes et de leurs biens ; il est réalisé à l’initiative du propriétaire.
                                    </div>
                                    <div className='sectionText'>
                                        Le diagnostic électricité concerne les installations qui ont plus de 15 ans, il est réalisé conformément à une méthodologie réglementée en contrôlant les différents composants depuis le compteur individuel jusqu’aux bornes de
                                        raccordement, prises et douilles d’ampoules et notamment : L’appareil général de commande et de protection Les fusibles, disjoncteurs et les dispositifs différentiels La prise de terre et les liaisons équipotentielles Les matériels
                                        vétustes Les règles liées aux zones dans les salles de bain…
                                    </div>
                                    <div className='sectionText'>
                                        Aucun déplacement de meubles ou de démontage d’installation n’est nécessaire, à l’exception des tableaux électriques qu’il convient d’ouvrir. Les anomalies détectées ainsi que les risques encourus sont consignées dans les rapports ;
                                        il est fortement conseillé de faire intervenir un homme de l’art en l’occurrence un électricien afin de les supprimer. Si le vendeur ne fournit pas le diagnostic et que l’acquéreur découvre que l’installation est défectueuse, il peut
                                        engager la responsabilité du vendeur pour vice caché.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticElectricitySection2Right'>
                                    <img src={diagnosticElectricitySection2} id='diagnosticElectricitySection2Image' alt='diagnostic-electricity-section2' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticElectricitySection3'>
                        <Col sm={6}>
                            <div id='diagnosticElectricitySection3Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={diagnosticElectricitySection3} className='diagnosticElectricitySection3Image' alt='diagnostic-electricity-section3' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='diagnosticElectricitySection3Right'>
                                    <h1 className='sectionTitle'>Pourquoi choisir E5M Diagnostics pour votre diagnostic électricité ?</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section3AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticElectricitySection4'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>Engagez E5M Diagnostics pour la Sécurité de Votre Bien</h1>
                            <div className='sectionText'>
                                Que vous soyez en processus de vente ou de location, le diagnostic électricité est une étape incontournable pour assurer la sécurité de votre bien et la sérénité des futurs occupants. En choisissant E5M Diagnostics,
                                vous optez pour un service expert, fiable et conforme aux exigences légales. Contactez-nous dès aujourd’hui pour planifier votre diagnostic électricité et prendre les mesures nécessaires pour la mise en conformité et la valorisation de votre propriété.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='diagnosticElectricity'>
                    <div id='header'>
                        <div id='diagnosticElectricityHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Diagnostic Électricité</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticElectricitySection1Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Votre partenaire de confiance pour un diagnostic électricité sécurisé</h1>
                            <div className='sectionTextMobile'>
                                La sécurité des installations électriques est une priorité absolue pour la vente ou la location de votre propriété. E5M Diagnostics comprends les enjeux liés à un diagnostic électricité fiable et conforme.
                                Nos experts certifiés vous accompagnent pour réaliser ce diagnostic essentiel, vous permettant de garantir la sécurité de votre bien et de répondre aux exigences réglementaires.
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticElectricitySection2Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Que ce que c'est diagnostic éléctricité</h1>
                            <div className='sectionTextMobile'>
                                Il est obligatoire d’effectuer un diagnostic électricité de l’installation intérieure afin d’évaluer les risques pouvant mettre en danger la sécurité des personnes et de leurs biens ; il est réalisé à l’initiative du propriétaire.
                            </div>
                            <div className='sectionTextMobile'>
                                Le diagnostic électricité concerne les installations qui ont plus de 15 ans, il est réalisé conformément à une méthodologie réglementée en contrôlant les différents composants depuis le compteur individuel jusqu’aux bornes de
                                raccordement, prises et douilles d’ampoules et notamment : L’appareil général de commande et de protection Les fusibles, disjoncteurs et les dispositifs différentiels La prise de terre et les liaisons équipotentielles Les matériels
                                vétustes Les règles liées aux zones dans les salles de bain…
                            </div>
                            <div className='sectionTextMobile'>
                                Aucun déplacement de meubles ou de démontage d’installation n’est nécessaire, à l’exception des tableaux électriques qu’il convient d’ouvrir. Les anomalies détectées ainsi que les risques encourus sont consignées dans les rapports ;
                                il est fortement conseillé de faire intervenir un homme de l’art en l’occurrence un électricien afin de les supprimer. Si le vendeur ne fournit pas le diagnostic et que l’acquéreur découvre que l’installation est défectueuse, il peut
                                engager la responsabilité du vendeur pour vice caché.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={diagnosticElectricitySection2} id='diagnosticElectricitySection2ImageMobile' alt='diagnostic-electricity-section2' />
                        </Fade>
                    </div>
                    <div id='diagnosticElectricitySection3Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={diagnosticElectricitySection3} className='diagnosticElectricitySection3ImageMobile' alt='diagnostic-electricity-section3' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Pourquoi choisir E5M Diagnostics pour votre diagnostic électricité ?</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section3AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticElectricitySection4Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Engagez E5M Diagnostics pour la Sécurité de Votre Bien</h1>
                            <div className='sectionTextMobile'>
                                Que vous soyez en processus de vente ou de location, le diagnostic électricité est une étape incontournable pour assurer la sécurité de votre bien et la sérénité des futurs occupants. En choisissant E5M Diagnostics,
                                vous optez pour un service expert, fiable et conforme aux exigences légales. Contactez-nous dès aujourd’hui pour planifier votre diagnostic électricité et prendre les mesures nécessaires pour la mise en conformité et la valorisation de votre propriété.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>


    )

}

export default DiagnosticElectricity